/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { Chip, Drawer, Stack } from "@mui/material";
import MuiDrawer from "component/atom/MuiDrawer";
import { useAtom, useSetAtom } from "jotai";
import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { searchDrawerReadDocument } from "service/searchDrawerService";
import { storeSearchCategory, storeSearchCity, storeSearchGu, storeSearchKeyword, storeSearchStart, storeSearchSubCategory } from "store/searchValue";

function SearchDrarwer ({openDrawer, setOpenDrawer}: any) {
    const [originCategoryList, setOriginCategoryList] = useState(new Array());
    const [categoryList, setCategoryList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([{id: "uuid", category: "카테고리를 먼저 선택해 주세요"}]);
    const [originAddress, setOriginAddress] = useState<any>([]);
    const [cityList, setCityList] = useState([]);
    const [guList, setGuList] = useState([]);
    
    const [searchCategory, setSearchCategory] = useAtom(storeSearchCategory)
    const [searchSubCategory, setSearchSubCategory] = useAtom(storeSearchSubCategory)
    const [searchCity, setSearchCity] = useAtom(storeSearchCity)
    const [searchGu, setSearchGu] = useAtom(storeSearchGu)
    const [searchKeyword, setSearchKeyword] = useAtom(storeSearchKeyword)
    const [searchStart, setSearchStart] = useAtom(storeSearchStart)

    useEffect(()=>{
        getFirebaseCategoryDocument()
        getFirebaseAddressDocument()
    }, [])

    const getFirebaseCategoryDocument = async () => {
        const querySnapshot = await searchDrawerReadDocument("category")

        let tmpMarkerList = new Array()
        querySnapshot.forEach((doc) => {
            tmpMarkerList.push(doc.data())
            // tmpMarkerList.push({...doc.data(), key: doc.data()?.id})

            const tmpTitle = doc.data().title
            if(tmpTitle === "카테고리") {
                let data2 = doc.data().info_list.map((item: any) => {
                    return {...item, key: item?.id}
                })
                setCategoryList(data2)
            }
        });

        setOriginCategoryList(tmpMarkerList)
    }

    const getFirebaseAddressDocument = async () => {
        const tmplist = new Array()

        const tmpAddressList = await searchDrawerReadDocument("address")
        tmpAddressList.forEach((doc) => {
            const tmpTitle = doc.data().title
            if(tmpTitle === "광역시도") {
                setCityList(doc.data().info_list)
            }
            tmplist.push(doc.data())
        });

        setOriginAddress(tmplist)
    }

    const onClickCategoryName = (categoryName: string) => {
        setSearchCategory(categoryName)

        setSearchSubCategory('')

        originCategoryList.forEach(((item) => {
            if(categoryName === item?.title) {
                let data2 = item.info_list.map((item2: any) => {
                    return {...item2, key: item2?.id ?? "!@#$1234"}
                })
                setSubCategoryList(data2)
            }
        }))
    };

    const onClickSubCategoryName = (categoryName: string) => {
        if(searchCategory) {
            setSearchSubCategory(categoryName)
        }
    };


    const onClickCityName = (cityName: string) => {
        setSearchCity(cityName)

        setSearchGu('')

        originAddress.forEach((item: any) => {
            if(item.title.includes(cityName)) {
                setGuList(item.info_list)
            }
        })
    }

    const onClickGuName = (guName: string) => {
        setSearchGu(guName)
    }

    const onChangeKeyword = (event: any) => {
        setSearchKeyword(event.target.value)
    }

    const onClickResetButton = () => {
        if(searchCategory || searchSubCategory || searchCity || searchGu || searchKeyword) {
            setSubCategoryList([{id: "uuid", category: "카테고리를 먼저 선택해 주세요"}])

            setSearchCategory('')
            setSearchSubCategory('')
            setSearchCity('')
            setSearchGu('')
            setSearchKeyword('')

            setSearchStart((prev) => prev + 1)
        } 
    }

    const onClickSearchButton = () => {
        setOpenDrawer(false)
        setSearchStart((prev) => prev + 1)
    }

    return(
        <MuiDrawer
            anchor={'bottom'}
            open={openDrawer}
            onClose={() => {
                if(!searchStart) {
                    onClickResetButton()
                }
                setOpenDrawer(false)
            }}
            PaperProps={{ square: false }}
            disableAutoFocus={true}
        >
            <div css={DrawerWrapperStyle}>

                <div css={CategoryWrapperStyle}>
                    <div css={CategoryTitleStyle}>
                        카테고리
                    </div>
                    <Stack direction="row" spacing={1} css={CategoryChipWrapperStyle}>
                        {categoryList?.map((item: any, index: any) => (
                            <Chip 
                                key={item.key}
                                label={item.category} 
                                onClick={() => onClickCategoryName(item.category)} 
                                css={item.category === searchCategory? CategoryChipStyle(true) : CategoryChipStyle(false)} 
                            />
                        ))}
                    </Stack>
                </div>

                <div css={CategoryWrapperStyle}>
                    <div css={CategoryTitleStyle}>
                        서브 카테고리
                    </div>
                    <Stack direction="row" spacing={1} css={CategoryChipWrapperStyle}>
                        {subCategoryList?.map((item: any, index: any) => (
                            <Chip 
                                key={item.key}
                                label={item.category} 
                                onClick={() => onClickSubCategoryName(item.category)} 
                                css={item.category === searchSubCategory? CategoryChipStyle(true) : CategoryChipStyle(false)} 
                            />
                        ))}
                    </Stack>
                </div>
                
                <div css={LocalWrapperStyle}>
                    <div css={LocalTitleStyle}>
                        지역
                    </div>
                    <div css={LocalCityGuStyle}>
                        <div css={LoacalCityWrapperStyle}>
                            <div css={LocalCityTitleStyle}>
                                광역시도
                            </div>
                            <div css={LocalCityListWrapperStyle}>
                                {cityList?.map((item, index) => (
                                    <div 
                                        key={item + index} 
                                        onClick={() => onClickCityName(item)} 
                                        css={searchCity === item ? LocalCityStyle(true) : LocalCityStyle(false)}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div css={LoacalCityWrapperStyle}>
                            <div css={LocalCityTitleStyle}>
                                시군구
                            </div>
                            <div css={LocalCityListWrapperStyle}>
                                {guList?.map((item, index) => (
                                    <div 
                                        key={item + index} 
                                        onClick={() => onClickGuName(item)} 
                                        css={searchGu === item ? LocalCityStyle(true) : LocalCityStyle(false)}
                                    >
                                    {item}
                                </div>
                                ))} 
                            </div>
                        </div>
                    </div>
                </div>

                <div css={KeywordWrapperStyle}>
                    <div css={KeywordTitleStyle}>
                        키워드
                    </div>
                    <div css={KeywordInputWrapperStyle}>
                        <input type="text" css={KeywordInputStyle} onChange={onChangeKeyword} value={searchKeyword}></input>
                        <FaSearch size={30}/>
                    </div>
                </div>                       

                <div css={ButtonWrapperStyle}>
                    <button css={ResetButtonStyle} onClick={onClickResetButton}>
                        초기화
                    </button>
                    <button css={SearchButtonStyle} onClick={onClickSearchButton}>
                        검색하기
                    </button>
                </div>
            </div>
        </MuiDrawer>
    )
}


const DrawerWrapperStyle = css`
    padding: 35px 21px;
`

// 카테고리 start---
const CategoryWrapperStyle = css`
    margin-bottom: 14px;
`

const CategoryTitleStyle = css`
    font-size: 19.3px;
    color: #000;
    font-weight: 700;
    margin-bottom: 14px;
`

const CategoryChipWrapperStyle = css`
    overflow-x: auto;
`

const CategoryChipStyle = (selectCategory: boolean) => css`
    color: ${selectCategory ? '#fff' : '#333'};
    background-color: ${selectCategory ?  '#02d0cc' : '#f0f0f0'};
    font-size: 14px;
    font-weight: 500;
`
// ----카테고리 end

// 지역검색 start----
const LocalWrapperStyle = css`
    margin-bottom: 14px;
`

const LocalTitleStyle = css`
    font-size: 19.3px;
    color: #000;
    font-weight: 700;
    margin-bottom: 14px;
`

const LocalCityGuStyle = css`
    display: flex;
    min-height: 236px;
    width: 100%;
`

const LoacalCityWrapperStyle = css`
    width: calc(50%);
    flex: 0 0 auto;
    border: 1px solid #e6e6e6;
`

const LocalCityTitleStyle = css`
    font-size: 14px;
    color: #000;
    font-weight: 600;
    text-align: center;
    background: #f4f4f4;
    padding: 8.8px 0;
    border-bottom: 1px solid #e6e6e6;
`

const LocalCityListWrapperStyle = css`
    max-height: 200px;
    margin: 5px 5px 5px 5px;
    overflow-y: auto;
`

const LocalCityStyle = (selectCity: boolean) => css`
    font-size: 14px;
    color: ${selectCity ? '#fff' : '#333'};
    background-color: ${selectCity ?  '#02d0cc' : '#fff'};
    font-weight: 500;
    padding: 4px 3px;
    text-align: center;
    margin: 0 auto;
    border-radius: 4.4px;
    cursor: pointer;
`
// --- 지역검색 end

// 키워드 검색 start ---
const KeywordWrapperStyle = css`
    margin-bottom: 14px;
`

const KeywordTitleStyle = css`
    font-size: 19.3px;
    color: #000;
    font-weight: 700;
    margin-bottom: 14px;
`

const KeywordInputWrapperStyle = css`
    display: flex;
    align-items: center;
    min-height: 50px;
    max-height: 50px;
    padding: 5px 17.5px;
    background: #f0f0f0;
    margin-bottom: 13.1px;
`

const KeywordInputStyle = css`
    width: 100%;
    font-size: 16.8px;
    color: #000;
    font-weight: 300;
    border: 1px solid transparent;
    background: transparent;
    height: 100%;
`
// --- 키워드 검색 end

// 버튼 start----
const ButtonWrapperStyle = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const ResetButtonStyle = css`
    width: 50%;
    font-size: 14px;
    color: #000;
    font-weight: 700;
    background-color: white;
    border-radius: 8.8px;
    padding: 10.5px 17.5px;
    border: 1px solid #000;
`

const SearchButtonStyle = css`
    width: 50%;
    font-size: 14px;
    color: #fff;
    font-weight: 700;
    background-color: #000;
    border-radius: 8.8px;
    padding: 10.5px 17.5px;
    border: 1px solid #000;
`

// ----버튼 end

export default SearchDrarwer;